;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React from 'react';

import cx from 'classnames';
import PropTypes from 'prop-types';

import Lockup from 'components/blocks/shared/Lockup';

import styles from './Card.module.scss';

const Card = ({
    isActive,
    isPrev,
    icon,
    eyebrow,
    headline,
    bodyCopy,
    cta,
    dirNext,
}) => {
    return (
        <div
            className={cx(styles.root, {
                [styles.isActive]: isActive,
                [styles.isPrev]: isPrev,
                [styles.dirNext]: dirNext,
            })}
        >
            <div className={styles.inner}>
                <Lockup
                    icon={icon}
                    eyebrow={{ text: eyebrow }}
                    headline={{ text: headline }}
                    copy={{ text: bodyCopy }}
                    ctas={cta}
                    theme="Small"
                />
            </div>
        </div>
    );
};

Card.propTypes = {
    isActive: PropTypes.bool,
    isPrev: PropTypes.bool,
    icon: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.shape({
            icon: PropTypes.shape({
                url: PropTypes.string,
            }),
        }),
    ]),
    eyebrow: PropTypes.string,
    headline: PropTypes.object.isRequired,
    bodyCopy: PropTypes.object.isRequired,
    cta: PropTypes.object,
    dirNext: PropTypes.bool,
};

export default Card;
